var map = {
	"./compas.svg": "5c4c",
	"./dude.svg": "6b8c",
	"./flag.svg": "0251",
	"./girl.svg": "6fed",
	"./news.svg": "7e92",
	"./pencil.svg": "33bf",
	"./rss.svg": "3637",
	"./support.svg": "2621"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";